
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/bihar/bihar-tak-baithak",
      function () {
        return require("private-next-pages/bihar/bihar-tak-baithak/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/bihar/bihar-tak-baithak"])
      });
    }
  